module.exports = __webpack_public_path__ + "static/media/ks_sensor_highlight.a92a3ff7.svg";